import React, { useState, useRef, useEffect } from 'react'
import * as THREE from 'three'

import colors from './predefinedColors'

import Stage from '../Stage'
import { MenuItem, Select } from '@material-ui/core'
import styles from '../designer.module.scss'

const SectionEditor = props => {
  const [selectedColor, setSelectedColor] = useState(new THREE.Color())
  const stage = Stage.getInstance()

  const changeMaterial = event => {
    setSelectedColor(event.target.value)
    const selection = Stage.outlinePass.selectedObjects
    for (let section of selection) {
      section.traverse(s => {
        if (s.type === 'Mesh') {
          s.material.color = event.target.value
          s.material.needsUpdate = true
        }
      })
    }
    stage.update()
  }

  useEffect(() => {
    const mats = []
    const selection = Stage.outlinePass.selectedObjects
    for (let section of selection) {
      section.traverse(s => {
        if (s.type === 'Mesh') {
          mats.push(s.material)
        }
      })
    }
    setSelectedColor(mats[0].color)
  }, [])

  return selectedColor ? (
    <div className={styles.sectionEditorPopup}>
      <Select
        disabled
        value={0}
        labelId="Material Type"
        id="materialType"
        fullWidth
      >
        <MenuItem value={0}>Leather</MenuItem>
        <MenuItem value={1}>fabric</MenuItem>
      </Select>
      <Select
        value={selectedColor}
        labelId="Color"
        id="color"
        onChange={changeMaterial}
        fullWidth
      >
        {colors.map((c, i) => (
          <MenuItem value={c.value} key={i}>
            <div className={styles.swatch}>
              <div
                style={{
                  height: '24px',
                  width: '36px',
                  borderRadius: '4px',
                  border: '1px solid black',
                  backgroundColor: `#${c.value.getHexString()}`,
                }}
              />
              <div className={styles.marginLeft}>
                -<span className={styles.marginLeft}>{c.name}</span>
              </div>
            </div>
          </MenuItem>
        ))}
      </Select>
    </div>
  ) : null
}

export default SectionEditor
